<div class="text-xl font-semibold">
	{{ ((module$ | async)?.localization$ | async)?.name }}
</div>
<div class="space-y-3">
	<div
		*ngFor="let page of pages$ | async; let i = index"
		class="flex items-stretch flex-col space-y-3"
	>
		<ng-container
			*ngIf="pagesArray.at(i) as pageControl"
			[formGroup]="pageControl"
		>
			<div class="flex items-center flex-row">
				<label class="flex-auto text-left">
					{{ (page.localization$ | async)?.title }}
				</label>
				<p-selectButton
					[options]="typeOptions$ | async"
					formControlName="type"
				></p-selectButton>
			</div>
			<div *ngIf="pageControl.value.type !== 'FILE'" class="p-inputgroup">
				<p-selectButton
					[options]="schemeOptions"
					formControlName="urlScheme"
				></p-selectButton>
				<input
					[placeholder]="
						'presentation.app.sidebar.plan.phase.section.module.edit.url.placeHolder'
							| translate
					"
					formControlName="activityUrl"
					pInputText
					style="width: 200px"
				/>
			</div>
			<div
				*ngIf="pageControl.value.type === 'FILE'"
				(click)="file.click()"
				class="
					flex
					p-3
					cursor-pointer
					border border-solid
					items-center
					flex-col
					justify-center
					upload-input
					p-border-color-component-background p-color-text-secondary
				"
			>
				<i
					*ngIf="!(uploading$ | async)"
					class="text-3xl leading-none fas fa-file-upload"
				></i>
				<span *ngIf="!(uploading$ | async)" style="margin-top: 5px">
					{{ pageControl.value.fileName }}
				</span>
				<p-progressSpinner
					*ngIf="uploading$ | async"
					[style]="{ width: '50px', height: '50px' }"
				></p-progressSpinner>
			</div>
			<input
				#file
				(change)="onFileChange($event, file, pageControl)"
				class="hidden"
				accept="*/*"
				type="file"
			/>
		</ng-container>
	</div>
</div>
<button
	[label]="
		'presentation.app.sidebar.plan.phase.section.module.edit.submit.label'
			| translate
	"
	(click)="onSaveClick()"
	pButton
></button>
